import { get as _get } from "lodash";
import { Request as JSONRequest } from "../helpers/request";

/**
 * Data of the explore pages: protocol totals, tokens and pools from the KoinDX API
 */
class ExploreController extends JSONRequest {
  constructor() {
    super({ url: import.meta.env.VITE_BACKEND_API_URL });
  }

  // { totalLiquidityUSD, totalVolumeUSD, txCount, pairCount, koinPriceUSD, ... }
  async getProtocol() {
    return _get(await this.getPrepared("/v2/protocol"), "result", null);
  }

  // every token with liquidity, with priceUSD and totalLiquidityUSD
  getTokens() {
    return this.getAllPages("/v2/tokens");
  }

  async getToken(id) {
    return _get(await this.getPrepared(`/v2/tokens/${id}`), "result", null);
  }

  // every pool with liquidity, each with its tokens
  getPools() {
    return this.getAllPages("/v2/pairs");
  }

  async getPool(id) {
    return _get(await this.getPrepared(`/v2/pairs/${id}`), "result", null);
  }
}

export let explore = new ExploreController();
